import { useContext, useEffect, useState } from "react";
import api from "../api/client";
import AuthContext from "../context/AuthContext";
import { Alert, Box, Button, Snackbar, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useScreen } from "../hooks/useScreen";

export default function Clients() {
  const { user } = useContext(AuthContext);
  const { isXs } = useScreen();
  const [clients, setClients] = useState([]);
  const [error, setError] = useState("");

  const columns = [
    { field: "name", headerName: "Nombre", flex: 1.2 },
    { field: "cuit", headerName: "CUIT", flex: 1 },
    { field: "location", headerName: "Ubicación", flex: 1 },
    { field: "mail", headerName: "Email", flex: 1.2 },
  ];

  useEffect(() => {
    if (!user?.is_admin) {
      setClients([]);
      setError("");
      return;
    }

    api
      .get("/clients/")
      .then((res) => {
        setClients(res.data);
        setError("");
      })
      .catch((err) => {
        setError(err?.response?.data?.detail || "No se pudieron cargar los clientes");
      });
  }, [user?.is_admin]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Clientes
      </Typography>

      {!user?.is_admin && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Solo un administrador puede ver la información del cliente.
        </Alert>
      )}

      {user?.is_admin && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <Button variant="outlined" disabled>
            Alta de cliente restringida
          </Button>
        </Box>
      )}

      {user?.is_admin && (
        <Box sx={{ width: "100%", height: isXs ? 360 : 420 }}>
          <DataGrid
            rows={clients}
            columns={columns}
            disableColumnMenu={isXs}
            density={isXs ? "compact" : "standard"}
            initialState={{
              pagination: { paginationModel: { pageSize: isXs ? 5 : 10 } },
            }}
            pageSizeOptions={[5, 10]}
            disableRowSelectionOnClick
          />
        </Box>
      )}

      <Snackbar
        open={Boolean(error)}
        autoHideDuration={4000}
        onClose={() => setError("")}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={() => setError("")} severity="error" variant="filled" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
}
